import ppm from "./ppm";

export default { ppm };
